export const CacheKeys = {
  DISCOVER_MERCHANTS: "discover_merchants_v1",
  FEED: "feedCache_v1",
  CATEGORIES: "categories_v1",
  SUBCATEGORIES: "subcategories_v1",
  ISSUED_COUPONS: "issued_coupons_v1",
};

export const CacheTTL = {
  V_MINS: 5 * 60 * 1000,
  QUARTER: 15 * 60 * 1000,
  HALF: 30 * 60 * 1000,
  HOUR: 60 * 60 * 1000,
};
